function getFormattedStatistics(statistics) {
	return statistics.reduce((acc, item) => {
		acc.labels.push(item.date);
		acc.data.push(+item['total_truck']);
		return acc;
	}, { labels: [], data: [] });
}

export function chartConfig(statistics) {
	const { labels, data } = getFormattedStatistics(statistics);
	return {
		labels,
		datasets: [
			{
				fill: {
					target: 'origin',
					above: 'rgba(143, 144, 166, 0.3)',
				},
				label: 'chart',
				backgroundColor: '#19BC38',
				borderColor: '#19BC38',
				data,
				lineTension: 0.4,
				pointRadius: 6,
				pointBorderWidth: 3,
				pointHoverBackgroundColor: '#ffffff',
				pointHoverBorderWidth: 3,
				pointHoverRadius: 6,
				borderWidth: 3,
			}
		]
	};
}

export const chartOptions = {
	responsive: true,
	maintainAspectRatio: false,
	backgroundColor: 'rgba(255, 255, 255, 1)',
	animations: {
		tension: {
			duration: 1000,
			easing: 'linear',
			from: 1,
			to: 0.4
		}
	},
	plugins: {
		legend: {
			display: false,
		},
		tooltip: {
			displayColors: false,
			callbacks: {
				title: () => '',
				label: (context) => {
					const { raw } = context;
					return `Total trucks ${ raw }`;
				}
			}
		}
	},
	scales: {
		x: { grid: { color: 'rgba(255, 255, 255, 0.2)' } },
		y: { grid: { color: 'rgba(255, 255, 255, 0.2)' }, beginAtZero: true }
	}
};
